import { render, staticRenderFns } from "./pgowner.vue?vue&type=template&id=0b9f9ac9&scoped=true&"
import script from "./pgowner.vue?vue&type=script&lang=js&"
export * from "./pgowner.vue?vue&type=script&lang=js&"
import style0 from "./pgowner.vue?vue&type=style&index=0&id=0b9f9ac9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f9ac9",
  null
  
)

export default component.exports